import { render, staticRenderFns } from "./SingleRule.vue?vue&type=template&id=16fbce50"
import script from "./SingleRule.vue?vue&type=script&lang=js"
export * from "./SingleRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports